import { TextField, Typography, Box } from "@material-ui/core";
import { Autocomplete } from "@material-ui/lab";
import { Button } from "components";
import { useState, useEffect } from "react";
import Drawer from "shared/Drawer";

import {
  IN_PROMOTION_OPTIONS,
  CURVA_OPTIONS,
  VARIACAO_AMEIXA_DIRECTION_OPTIONS
} from "../../mocks";
import { useStyles } from "./styles";

const FilterDrawer = ({
  open,
  onClose,
  onApply,
  onClear,
  initialParams,
  categories
}) => {
  const classes = useStyles();

  const [selectedCategories, setSelectedCategories] = useState(
    initialParams?.categorias ?? []
  );
  const [selectedPromotion, setSelectedPromotion] = useState(
    initialParams?.em_promocao ?? null
  );
  const [selectedCurva, setSelectedCurva] = useState(
    initialParams?.curva ?? null
  );
  const [selectedVariacaoDirection, setSelectedVariacaoDirection] = useState(
    initialParams?.variacao_ameixa_direction ?? "all"
  );

  useEffect(() => {
    if (!initialParams) return;
    setSelectedCategories(initialParams.categorias ?? []);
    setSelectedPromotion(initialParams.em_promocao ?? null);
    setSelectedCurva(initialParams.curva ?? null);
    setSelectedVariacaoDirection(
      initialParams.variacao_ameixa_direction ?? "all"
    );
  }, [initialParams]);

  const handleApply = () => {
    onApply({
      categorias:
        selectedCategories.length > 0 ? selectedCategories : undefined,
      em_promocao: selectedPromotion !== null ? selectedPromotion : undefined,
      curva: selectedCurva !== null ? selectedCurva : undefined,
      variacao_ameixa_direction:
        selectedVariacaoDirection !== "all"
          ? selectedVariacaoDirection
          : undefined
    });
    onClose();
  };

  const handleClear = () => {
    setSelectedCategories(initialParams?.categorias ?? []);
    setSelectedPromotion(null);
    setSelectedCurva(null);
    setSelectedVariacaoDirection("all");
    onClear();
    onClose();
  };

  return (
    <Drawer open={open} onClose={onClose} title="Filtros" anchor="right">
      <Box className={classes.drawerContent}>
        <Box className={classes.scrollableContent}>
          <Box className={`${classes.filterSection} ${classes.inputSection}`}>
            <Typography className={classes.sectionTitle}>Categoria</Typography>
            <Autocomplete
              multiple
              options={categories}
              getOptionLabel={option => option.label}
              value={categories.filter(c => selectedCategories.includes(c.id))}
              onChange={(_, newValue) => {
                setSelectedCategories(
                  (newValue || []).map(option => option.id)
                );
              }}
              renderInput={params => (
                <TextField
                  {...params}
                  variant="outlined"
                  placeholder="Selecione a categoria"
                />
              )}
            />
          </Box>

          <Box className={`${classes.filterSection} ${classes.inputSection}`}>
            <Typography className={classes.sectionTitle}>Promoção</Typography>
            <Autocomplete
              options={IN_PROMOTION_OPTIONS}
              getOptionLabel={option => option.label}
              value={
                IN_PROMOTION_OPTIONS.find(o => o.value === selectedPromotion) ||
                null
              }
              onChange={(_, newValue) => {
                setSelectedPromotion(newValue?.value ?? null);
              }}
              renderInput={params => (
                <TextField {...params} variant="outlined" placeholder="Todos" />
              )}
            />
          </Box>

          <Box className={`${classes.filterSection} ${classes.inputSection}`}>
            <Typography className={classes.sectionTitle}>Curva</Typography>
            <Autocomplete
              options={CURVA_OPTIONS}
              getOptionLabel={option => option.label}
              value={CURVA_OPTIONS.find(o => o.value === selectedCurva) || null}
              onChange={(_, newValue) => {
                setSelectedCurva(newValue?.value ?? null);
              }}
              renderInput={params => (
                <TextField {...params} variant="outlined" placeholder="Todas" />
              )}
            />
          </Box>

          <Box className={`${classes.filterSection} ${classes.inputSection}`}>
            <Typography className={classes.sectionTitle}>
              Variação P. Atual
            </Typography>
            <Autocomplete
              options={VARIACAO_AMEIXA_DIRECTION_OPTIONS}
              getOptionLabel={option => option.label}
              value={
                VARIACAO_AMEIXA_DIRECTION_OPTIONS.find(
                  o => o.value === selectedVariacaoDirection
                ) || VARIACAO_AMEIXA_DIRECTION_OPTIONS[0]
              }
              onChange={(_, newValue) => {
                setSelectedVariacaoDirection(newValue?.value ?? "all");
              }}
              renderInput={params => (
                <TextField {...params} variant="outlined" placeholder="Todas" />
              )}
            />
          </Box>
        </Box>

        <Box className={classes.buttonsContainer}>
          <Button
            variant="outlined"
            color="default"
            onClick={handleClear}
            fullWidth
            className={classes.clearButton}
          >
            Limpar filtros
          </Button>
          <Button
            variant="contained"
            color="primary"
            onClick={handleApply}
            fullWidth
          >
            Aplicar filtros
          </Button>
        </Box>
      </Box>
    </Drawer>
  );
};

export default FilterDrawer;
